import type { NavItem } from '@assessments/shared'

export interface ActiveNavEntry {
  itemIndex: number
  /** Null when the active entry is the top-level item itself rather than a child. */
  childIndex: number | null
}

/**
 * The active entry, taken from the feed rather than derived from the current route.
 * The platform owns which of its destinations the app stands for; matching its
 * `active_route_pattern` here is not possible — it is a Laravel route-name glob and
 * this app has no route name to match against.
 *
 * Keeps the first flag in render order: the feed should carry at most one, but a producer
 * bug must degrade to a single highlight rather than several.
 */
export function resolveActiveNavEntry(items: NavItem[]): ActiveNavEntry | null {
  for (const [itemIndex, item] of items.entries()) {
    if (item.is_active) return { itemIndex, childIndex: null }
    const childIndex = item.children.findIndex((child) => child.is_active)
    if (childIndex !== -1) return { itemIndex, childIndex }
  }
  return null
}
